import React, { useCallback, useState, useMemo, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label } from 'reactstrap';
import { Transforms, Editor as SlateEditor, Range, Point, createEditor } from 'slate';
import { Slate, Editable, withReact, ReactEditor } from 'slate-react';
import { withHistory } from 'slate-history';
import isUrl from 'is-url';
/* import imageExtensions from 'image-extensions'; */
import { css } from '@emotion/css';
import { ToolbarButton, Icon } from './components';
import { initialValue, defaultColors, defaultImage, defaultStyle } from './InitilValue';
import { EmojiList } from './Emojis';
import { getStyleFromHtmlStyle } from './HelperFucntions';
export let Editor = [];
export const setEditorValue = (value, e) => {
    if (e && e.current) {
        e.current.children = value;
    }
};
const LIST_TYPES = ['numbered-list', 'bulleted-list'];
const TEXT_ALIGN_TYPES = ['align-left', 'align-center', 'align-right', 'align-justify'];
/* const HEADING_TYPES = ['heading-one', 'heading-2', 'heading-3', 'heading-4', 'heading-5']; */
const SharedAppContext = React.createContext({});
export const FontColorButton = (props) => {
    const { format, className } = props;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { editor, isMarkActive, setFontCol, fontColor } = propps;
        return (React.createElement(ToolbarButton, { className: `fontColor_button ${className}`, onMouseDown: () => { } },
            React.createElement(Input, { type: "color", style: { width: '60px', height: '35px' }, value: fontColor, onChange: (e) => {
                    setFontCol(e, editor);
                }, className: `fontColor_input`, active: isMarkActive(editor, format) })));
    }));
};
export const BlockButton = (props) => {
    const { format, icon, className } = props;
    const headingNumberIndex = format.indexOf('-');
    const headingNumber = icon === 'fa fa-header' && format.slice(headingNumberIndex + 1);
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { editor, isBlockActive, toggleBlock, colors } = propps;
        return (React.createElement(ToolbarButton, { className: `block_button ${className}`, active: isBlockActive(editor, format), onMouseDown: (event) => {
                event.preventDefault();
                toggleBlock(editor, format);
            }, colors: colors }, icon === 'fa fa-header' ? (React.createElement(React.Fragment, null,
            React.createElement(Icon, { buttonIcons: [icon], className: icon }),
            headingNumber && headingNumber)) : (React.createElement(Icon, { buttonIcons: [icon], className: icon }))));
    }));
};
export const MarkButton = (props) => {
    const { format, icon, className } = props;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { editor, isMarkActive, toggleMark, colors } = propps;
        return (React.createElement(ToolbarButton, { className: `mark_button ${className}`, active: isMarkActive(editor, format), onMouseDown: (event) => {
                event.preventDefault();
                toggleMark(editor, format);
            }, colors: colors },
            React.createElement(Icon, { buttonIcons: [icon], className: icon })));
    }));
};
export const FontsizeButton = (props) => {
    const { format, editor, setFontSize, isFontSizeActive, fontSize, setFont, className } = props;
    return (React.createElement(ToolbarButton, { className: `font_button ${className}`, style: { position: 'relative', top: '-3px', left: '15px' }, onMouseUp: () => { }, name: format, active: isFontSizeActive(editor, setFontSize) },
        React.createElement("select", { name: "fontsize", id: "fontsize", value: fontSize, onChange: (e) => {
                setFont(e, editor);
            }, className: "font_button", onMouseUp: () => { } },
            React.createElement("option", { key: "17px", value: "17px" }, "17 px"),
            React.createElement("option", { key: "18px", value: "18px" }, "18 px"),
            React.createElement("option", { key: "19px", value: "19px" }, "19 px"),
            React.createElement("option", { key: "20px", value: "20px" }, "20 px"),
            React.createElement("option", { key: "21px", value: "21px" }, "21 px"),
            React.createElement("option", { key: "22px", value: "22px" }, "22 px"),
            React.createElement("option", { key: "23px", value: "23px" }, "23 px"),
            React.createElement("option", { key: "24px", value: "24px" }, "24 px"),
            React.createElement("option", { key: "25px", value: "25px" }, "25 px"))));
};
export const TableButton = (props) => {
    const { icon, format, plusIcon, className } = props;
    const align = format.substring(format.indexOf('-') + 1, format.length);
    const plusIc = plusIcon || `fa-solid fa-align-${align}`;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { toggleTableModal } = propps;
        return (React.createElement(ToolbarButton, { className: `table_button ${className}`, onClick: () => toggleTableModal(format) },
            React.createElement(Icon, { buttonIcons: [plusIc, icon], className: icon })));
    }));
};
export const ImageButton = (props) => {
    const { icon, format, plusIcon, className } = props;
    const align = format.substring(format.indexOf('-') + 1, format.length);
    const plusIco = plusIcon ? plusIcon : align === 'image' ? `fa-solid fa-align-justify` : `fa-solid fa-align-${align}`;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { toggleImageModal } = propps;
        return (React.createElement(ToolbarButton, { className: `image_button ${className || ''}`, onClick: () => toggleImageModal(format) },
            React.createElement(Icon, { buttonIcons: align === 'image' ? [icon] : [plusIco, icon], className: icon })));
    }));
};
export const CustomButton = (props) => {
    const { format, key, className, text } = props;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { editor, addText, colors } = propps;
        return (React.createElement(ToolbarButton, { key: key, style: { width: 'fit-content' }, className: `custom_button ${className || ''}`, onMouseDown: (event) => {
                event.preventDefault();
                addText(editor, format);
            }, colors: colors }, text));
    }));
};
export const LinkButton = (props) => {
    const { icon, className } = props;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { editor, isLinkActive, toggleLinkModal } = propps;
        return (React.createElement(ToolbarButton, { active: isLinkActive(editor), className: `link_button ${className || ''}`, onClick: () => toggleLinkModal() },
            React.createElement(Icon, { buttonIcons: [icon], className: icon })));
    }));
};
export const RemoveLinkButton = (props) => {
    const { format, icon, className } = props;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { editor, isLinkActive, unwrapLink } = propps;
        return (React.createElement(ToolbarButton, { active: isLinkActive(editor), className: `removelink_button ${className || ''}`, format: format, onClick: () => {
                if (isLinkActive(editor)) {
                    unwrapLink(editor);
                }
            } },
            React.createElement(Icon, { buttonIcons: [icon], className: icon })));
    }));
};
export const ToggleEditableButtonButton = (props) => {
    const { format, icon, className } = props;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { editor, isButtonActive, unwrapButton, toggleCTAModal } = propps;
        return (React.createElement(ToolbarButton, { format: format, active: isButtonActive(editor), className: `cta_button ${className || ''}`, onMouseDown: (event) => {
                event.preventDefault();
                if (isButtonActive(editor)) {
                    unwrapButton(editor);
                }
                else {
                    toggleCTAModal();
                }
            } },
            React.createElement(Icon, { buttonIcons: [icon], className: icon })));
    }));
};
export const YoutubeButton = (props) => {
    const { icon, className } = props;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { toggleYoutubeModal } = propps;
        return (React.createElement(ToolbarButton, { className: `youtube_button ${className || ''}`, onClick: () => toggleYoutubeModal() },
            React.createElement(Icon, { buttonIcons: [icon], className: icon })));
    }));
};
export const EmojiButton = (props) => {
    const { icon, className } = props;
    return (React.createElement(SharedAppConsumer, null, (propps) => {
        const { toggleEmojiModal } = propps;
        return (React.createElement(ToolbarButton, { className: `emoji_button ${className}`, onClick: () => toggleEmojiModal() },
            React.createElement(Icon, { buttonIcons: [icon], className: icon })));
    }));
};
export const Wysiwyg = ({ className = 'react-slate-wysiwyg', editorClass = 'react-slate-wysiwyg-editor', children, id, value = initialValue, colors = defaultColors, placeholder = 'Ide írjon szöveget...', uploadType = 'link', customButtons = [], onChange, as: Component = 'div' }) => {
    const toggleImageModal = (format) => {
        setImageModal(!imageModal);
        if (format) {
            setFormat(format);
        }
    };
    function toggleBlock(editor, format) {
        var _a, _b, _c;
        const isActive = isBlockActive(editor, format);
        const isList = LIST_TYPES.includes(format);
        Transforms.unwrapNodes(editor, {
            match: (n) => {
                return !SlateEditor.isEditor(n) && LIST_TYPES.includes(n.type) && !TEXT_ALIGN_TYPES.includes(format);
            },
            split: true
        });
        let newProperties = {};
        if (TEXT_ALIGN_TYPES.includes(format)) {
            const { selection } = editor;
            if (selection) {
                const [parent] = SlateEditor.parent(editor, (_a = selection.focus) === null || _a === void 0 ? void 0 : _a.path);
                let style = Object.assign({}, parent.style);
                let f = format.substring(format.lastIndexOf('-') + 1, format.length);
                const newStyle = Object.assign(style, { textAlign: f });
                if ((parent && parent.type.includes('heading') && format.includes('align')) || (parent && parent.type.includes('align') && format.includes('heading'))) {
                    delete newStyle['fontSize'];
                }
                newProperties = {
                    align: isActive ? undefined : f,
                    style: newStyle,
                    type: `${parent && parent.type.includes('heading') && format.includes('align') ? parent.type : `align-${f}`}`
                };
            }
        }
        else {
            const { selection } = editor;
            if (selection) {
                const [parent] = SlateEditor.parent(editor, (_b = selection.focus) === null || _b === void 0 ? void 0 : _b.path);
                newProperties = {
                    type: isActive ? 'align-left' : isList ? 'list-item' : format,
                    align: isActive ? undefined : format,
                    style: format.includes('heading') && parent && parent.type.includes('align') ? {} : { fontSize: '17px' }
                };
            }
        }
        Transforms.setNodes(editor, newProperties);
        if (!isActive && isList) {
            const { selection } = editor;
            if (selection) {
                const [parent] = SlateEditor.parent(editor, (_c = selection.focus) === null || _c === void 0 ? void 0 : _c.path);
                newProperties = {
                    type: isActive ? 'align-left' : isList ? 'list-item' : format,
                    align: isActive ? undefined : format,
                    style: format.includes('heading') && parent && parent.type.includes('align') ? {} : { fontSize: '17px' }
                };
                const block = {
                    type: format,
                    style: format.includes('heading') && parent && parent.type.includes('align') ? {} : { fontSize: '17px' },
                    children: []
                };
                Transforms.wrapNodes(editor, block);
            }
        }
    }
    const isBlockActive = (editor, format, blockType = 'type') => {
        const obj = { keyName: blockType };
        const { selection } = editor;
        if (!selection)
            return false;
        const [match] = Array.from(SlateEditor.nodes(editor, {
            at: SlateEditor.unhangRange(editor, selection),
            match: (n) => {
                return !SlateEditor.isEditor(n) && n[obj.keyName] === format;
            }
        }));
        return !!match;
    };
    function isMarkActive(editor, format, color) {
        const [match] = SlateEditor.nodes(editor, {
            match: (n) => n[format] === true,
            universal: true
        });
        return !!match;
    }
    const toggleMark = (editor, format) => {
        const isActive = isMarkActive(editor, format);
        if (isActive) {
            SlateEditor.removeMark(editor, format);
        }
        else {
            SlateEditor.addMark(editor, format, true);
        }
    };
    const isFontSizeActive = (editor, setFontSize) => {
        const [match] = SlateEditor.nodes(editor, {
            match: (n) => {
                if (n['style']) {
                    setFontSize(n['style'].fontSize);
                }
                else {
                    setFontSize('17px');
                }
                return n['style'];
            },
            universal: true
        });
        return !!match;
    };
    const addText = (editor, text) => {
        const variable = {
            text: text
        };
        Transforms.insertNodes(editor, variable);
    };
    const addImage = (editor, image) => {
        const text = { text: '', style: { display: 'none' } };
        let style = {};
        /* let divStyle = {}; */
        if (format === 'image-left' || format === 'image-right') {
            if (format === 'image-left') {
                style = {
                    float: 'left',
                    margin: '20px 20px 20px 0px',
                    clear: 'both',
                    width: image.width + 'px',
                    height: image.height + 'px'
                };
            }
            if (format === 'image-right') {
                style = {
                    float: 'right',
                    margin: '20px 0px 20px 20px',
                    clear: 'both',
                    width: image.width + 'px',
                    height: image.height + 'px'
                };
            }
            const img = {
                type: format,
                style: Object.assign(style, {
                    width: image.width + 'px',
                    height: image.height + 'px'
                }),
                src: image.src,
                alt: image.alt,
                children: [text]
            };
            /*   const d: CustomElement = { type: 'div', style: divStyle, children: [img] }; */
            Transforms.insertNodes(editor, img);
            /*   Transforms.wrapNodes(editor, d); */
        }
        else {
            if (format === 'image-center') {
                style = Object.assign(style, {
                    display: 'block',
                    margin: '0 auto',
                    width: image.width + 'px',
                    height: image.height + 'px'
                });
            }
            const img = {
                type: format,
                style: style,
                src: image.src,
                alt: image.alt,
                children: [text]
            };
            Transforms.insertNodes(editor, img);
        }
    };
    const addTablazat = (editor, tableClass, rowNumber, colNumber, textAlign) => {
        let tableStyle = {};
        const align = format.substring(format.lastIndexOf('-') + 1, format.length);
        if (align === 'center') {
            tableStyle = {
                textAlign: textAlign || 'left',
                margin: '0px auto'
            };
        }
        else if (align === 'right') {
            tableStyle = {
                marginLeft: 'auto',
                marginRight: '0px'
            };
        }
        else if (align === 'left') {
            tableStyle = {
                marginLeft: '0px',
                marginRight: 'auto'
            };
        }
        let rowStyle = { border: '1px solid black' };
        let colStyle = { border: '1px solid black', padding: '5px 10px' };
        let rows = [];
        for (let i = 0; i < rowNumber; i++) {
            let cols = [];
            for (let j = 0; j < colNumber; j++) {
                cols.push({
                    type: 'table-cell',
                    style: colStyle,
                    children: [{ text: `cell-${j}`, style: { fontSize: '17px' } }]
                });
            }
            rows.push({ type: 'table-row', style: rowStyle, children: cols });
        }
        const table = {
            type: format,
            style: tableStyle,
            className: tableClass,
            children: rows
        };
        Transforms.insertNodes(editor, table);
        toggleTableModal();
    };
    const withInlines = (editor) => {
        const { insertData, insertText, isInline, isElementReadOnly, isSelectable } = editor;
        editor.isInline = (element) => ['link', 'button', 'badge'].includes(element.type) || isInline(element);
        editor.isElementReadOnly = (element) => element.type === 'badge' || isElementReadOnly(element);
        editor.isSelectable = (element) => element.type !== 'badge' && isSelectable(element);
        editor.insertText = (text) => {
            if (text && isUrl(text)) {
                wrapLink(editor, text);
            }
            else {
                insertText(text);
            }
        };
        editor.insertData = (data) => {
            const text = data.getData('text/plain');
            if (text && isUrl(text)) {
                wrapLink(editor, text);
            }
            else {
                insertData(data);
            }
        };
        return editor;
    };
    const insertLink = (editor, url, text, color) => {
        if (editor.selection) {
            wrapLink(editor, url, text, color);
            toggleLinkModal();
        }
    };
    const insertButton = (editor, CTALeiras, CTAFunc, CTAColor, CTABgColor) => {
        if (editor.selection) {
            wrapButton(editor, CTALeiras, CTAFunc, CTAColor, CTABgColor);
            toggleCTAModal();
        }
    };
    const insertYoutube = (editor, youtubeUrl, youtubeWidth, youtubeHeight) => {
        var _a;
        const { selection } = editor;
        const text = { text: '', style: { display: 'none' } };
        if (selection) {
            const [parent] = SlateEditor.parent(editor, (_a = selection.focus) === null || _a === void 0 ? void 0 : _a.path);
            const videoId = youtubeUrl.substring(youtubeUrl.indexOf('=', 1) + 1, youtubeUrl.indexOf('&', 1) === -1 ? youtubeUrl.length : youtubeUrl.indexOf('&', 1));
            let url = `https://www.youtube.com/embed/${videoId}`;
            let newStyle = {};
            if (parent.type === 'align-center')
                newStyle = { display: 'block', margin: '0 auto' };
            if (parent.type === 'align-right')
                newStyle = { display: 'block', marginLeft: 'auto', marginRight: '0px' };
            if (parent.type === 'align-left')
                newStyle = { display: 'block', marginLeft: '0px', marginRight: 'auto' };
            const youtube = {
                type: 'embeded',
                style: newStyle,
                youtubeUrl: url,
                width: youtubeWidth,
                height: youtubeHeight,
                children: [text]
            };
            Transforms.insertNodes(editor, youtube);
        }
    };
    const isLinkActive = (editor) => {
        const { selection } = editor;
        if (!selection)
            return false;
        const [match] = Array.from(SlateEditor.nodes(editor, {
            at: SlateEditor.unhangRange(editor, selection),
            match: (n) => {
                return !SlateEditor.isEditor(n) && n.type === 'link';
            }
        }));
        return !!match;
    };
    const isButtonActive = (editor) => {
        const [button] = SlateEditor.nodes(editor, {
            match: (n) => !SlateEditor.isEditor(n) && n.type === 'button'
        });
        return !!button;
    };
    const unwrapLink = (editor) => {
        Transforms.unwrapNodes(editor, {
            match: (n) => !SlateEditor.isEditor(n) && n.type === 'link'
        });
    };
    const unwrapButton = (editor) => {
        Transforms.unwrapNodes(editor, {
            match: (n) => !SlateEditor.isEditor(n) && n.type === 'button'
        });
    };
    const wrapLink = (editor, url, linkText, linkColor) => {
        if (isLinkActive(editor)) {
            unwrapLink(editor);
        }
        const { selection } = editor;
        const isCollapsed = selection && Range.isCollapsed(selection);
        const link = {
            type: 'link',
            url,
            style: {
                color: linkColor,
                textDecoration: 'none'
            },
            linkText: linkText,
            children: isCollapsed ? [{ text: linkText }] : []
        };
        if (isCollapsed) {
            Transforms.insertNodes(editor, link);
        }
        else {
            Transforms.wrapNodes(editor, link, { split: true });
            Transforms.collapse(editor, { edge: 'end' });
        }
    };
    const wrapButton = (editor, CTALeiras, CTAFunc, CTAColor, CTABgColor) => {
        if (isButtonActive(editor)) {
            unwrapButton(editor);
        }
        const { selection } = editor;
        const isCollapsed = selection && Range.isCollapsed(selection);
        const link = {
            type: 'link',
            url: CTAFunc,
            style: {
                color: CTAColor
            },
            children: [{ text: CTALeiras }]
        };
        const button = {
            type: 'button',
            style: {
                color: CTAColor,
                backgroundColor: CTABgColor
            },
            CTAFunc: CTAFunc,
            CTALeiras: CTALeiras,
            CTAColor: CTAColor,
            CTABgColor: CTABgColor,
            children: isCollapsed ? [link] : []
        };
        if (isCollapsed) {
            Transforms.insertNodes(editor, button);
        }
        else {
            Transforms.wrapNodes(editor, button, { split: true });
            Transforms.collapse(editor, { edge: 'end' });
        }
    };
    // Put this at the start and end of an inline component to work around this Chromium bug:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
    const InlineChromiumBugfix = () => (React.createElement("span", { contentEditable: false, className: css `
                font-size: 0;
            ` }, String.fromCodePoint(160) /* Non-breaking space */));
    const LinkComponent = (props) => {
        let newStyle = {};
        const { attributes, element } = props;
        Object.assign(newStyle, element.style);
        Object.assign(newStyle, { textDecoration: 'none' });
        return (React.createElement("a", Object.assign({}, attributes, { href: element.url, style: newStyle }),
            React.createElement(InlineChromiumBugfix, null),
            element.linkText,
            React.createElement(InlineChromiumBugfix, null)));
    };
    const EditableButtonComponent = (props) => {
        const { attributes, element } = props;
        const { CTALeiras, CTAFunc, CTAColor, CTABgColor } = element;
        return (
        /*
        Note that this is not a true button, but a span with button-like CSS.
        True buttons are display:inline-block, but Chrome and Safari
        have a bad bug with display:inline-block inside contenteditable:
        - https://bugs.webkit.org/show_bug.cgi?id=105898
        - https://bugs.chromium.org/p/chromium/issues/detail?id=1088403
        Worse, one cannot override the display property: https://github.com/w3c/csswg-drafts/issues/3226
        The only current workaround is to emulate the appearance of a display:inline button using CSS.
      */
        React.createElement("button", Object.assign({}, attributes, { onClick: (ev) => {
                ev.preventDefault();
            }, type: "button", style: { backgroundColor: CTABgColor, padding: '10px' }, 
            // Margin is necessary to clearly show the cursor adjacent to the button
            className: css `
                    margin: 0 0.1em;
                ` }),
            React.createElement(InlineChromiumBugfix, null),
            React.createElement("a", { href: CTAFunc, style: {
                    color: CTAColor,
                    textDecoration: 'none',
                    fontSize: fontSize
                }, target: "_blank" }, CTALeiras),
            React.createElement(InlineChromiumBugfix, null)));
    };
    const BadgeComponent = (props) => {
        const { attributes, children } = props;
        return (React.createElement("span", Object.assign({}, attributes, { contentEditable: false, className: css `
                    background-color: green;
                    color: white;
                    padding: 2px 6px;
                    border-radius: 2px;
                    font-size: 0.9em;
                ` }),
            React.createElement(InlineChromiumBugfix, null),
            children,
            React.createElement(InlineChromiumBugfix, null)));
    };
    const addYoutube = (editor, youtubeUrl, youtubeWidth, youtubeHeight) => {
        insertYoutube(editor, youtubeUrl, youtubeWidth, youtubeHeight);
    };
    const addCTA = (editor, CTALeiras, CTAFunc, CTAColor, CTABgColor) => {
        insertButton(editor, CTALeiras, CTAFunc, CTAColor, CTABgColor);
    };
    const addEmoji = (editor, emoji) => {
        editor.insertText(emoji);
    };
    /* const isImageUrl = (url: string) => {
        if (!url) return false;
        if (!isUrl(url)) return false;
        const ext = new URL(url).pathname.split('.').pop() || '';
        return imageExtensions.includes(ext);
    }; */
    const withTables = (editor) => {
        const { deleteBackward, deleteForward, insertBreak } = editor;
        editor.deleteBackward = (unit) => {
            const { selection } = editor;
            if (selection && Range.isCollapsed(selection)) {
                const [cell] = SlateEditor.nodes(editor, {
                    match: (n) => !SlateEditor.isEditor(n) && n.type === 'table-cell'
                });
                if (cell) {
                    const [, cellPath] = cell;
                    const start = SlateEditor.start(editor, cellPath);
                    if (Point.equals(selection.anchor, start)) {
                        return;
                    }
                }
            }
            deleteBackward(unit);
        };
        editor.deleteForward = (unit) => {
            const { selection } = editor;
            if (selection && Range.isCollapsed(selection)) {
                const [cell] = SlateEditor.nodes(editor, {
                    match: (n) => !SlateEditor.isEditor(n) && n.type === 'table-cell'
                });
                if (cell) {
                    const [, cellPath] = cell;
                    const end = SlateEditor.end(editor, cellPath);
                    if (Point.equals(selection.anchor, end)) {
                        return;
                    }
                }
            }
            deleteForward(unit);
        };
        editor.insertBreak = () => {
            const { selection } = editor;
            if (selection) {
                const [table] = SlateEditor.nodes(editor, {
                    match: (n) => !SlateEditor.isEditor(n) && n.type === 'table'
                });
                if (table) {
                    return;
                }
            }
            insertBreak();
        };
        return editor;
    };
    const withImages = (editor) => {
        const { isVoid } = editor;
        editor.isVoid = (element) => {
            return element.type === 'image' || element.type === 'image-center' || element.type === 'image-right' || element.type === 'image-left' ? true : isVoid(element);
        };
        return editor;
    };
    const defaultModalValues = {
        tableClass: 'wysiwyg-table',
        rowNumber: '',
        colNumber: '',
        textAlign: '',
        linkUrl: '',
        linkFontColor: '',
        linkDesc: '',
        youtubeUrl: '',
        youtubeWidth: '',
        youtubeHeight: '',
        CTALeiras: '',
        CTABgColor: '',
        CTAFontColor: '',
        CTAFunc: ''
    };
    const editor = useMemo(() => withImages(withTables(withInlines(withHistory(withReact(createEditor()))))), []);
    Editor = useRef(editor);
    const [fontSize, setFontSize] = useState('17px');
    const [fontColor, setFontColor] = useState('#000000');
    const [imageModal, setImageModal] = useState(false);
    const [tableModal, setTableModal] = useState(false);
    const [linkModal, setLinkModal] = useState(false);
    const [youtubeModal, setYoutubeModal] = useState(false);
    const [CTAModal, setCTAModal] = useState(false);
    const [emojiModal, setEmojiModal] = useState(false);
    const [image, setImage] = useState(defaultImage);
    const [format, setFormat] = useState('');
    const [modalValues, setModalvalues] = useState(defaultModalValues);
    const [images] = useState([]);
    const toggleTableModal = (format) => {
        setTableModal(!tableModal);
        if (format) {
            setFormat(format);
        }
    };
    const toggleLinkModal = () => {
        setModalvalues(Object.assign(Object.assign({}, modalValues), { linkDesc: '', linkFontColor: '', linkUrl: '' }));
        setLinkModal(!linkModal);
    };
    const toggleYoutubeModal = () => {
        setModalvalues(Object.assign(Object.assign({}, modalValues), { youtubeHeight: '', youtubeWidth: '', youtubeUrl: '' }));
        setYoutubeModal(!youtubeModal);
    };
    const toggleCTAModal = () => {
        setModalvalues(Object.assign(Object.assign({}, modalValues), { CTABgColor: '', CTAFontColor: '', CTAFunc: '', CTALeiras: '' }));
        setCTAModal(!CTAModal);
    };
    const toggleEmojiModal = () => {
        setEmojiModal(!emojiModal);
    };
    const isParentHeading = (props) => {
        const parent = props.children && props.children.props.parent && props.children.props.parent;
        if (parent) {
            if (parent.type === 'heading-1' || parent.type === 'heading-2' || parent.type === 'heading-3' || parent.type === 'heading-4' || parent.type === 'heading-5') {
                return true;
            }
            else {
                return false;
            }
        }
    };
    const deleteImage = (editor, element) => {
        const path = ReactEditor.findPath(editor, element);
        Transforms.removeNodes(editor, { at: path });
    };
    const Leaf = (props) => {
        let { attributes, children, leaf } = props;
        let style = leaf.style;
        let headingStyle = {
            textAlign: style && style.textAlign ? style.textAlign : undefined
        };
        if (leaf.bold) {
            children = React.createElement("strong", null, children);
        }
        if (leaf.code) {
            children = React.createElement("code", null, children);
        }
        if (leaf.italic) {
            children = React.createElement("em", null, children);
        }
        if (leaf.underline) {
            children = React.createElement("u", null, children);
        }
        if (leaf.emoji) {
            const newStyle = getStyleFromHtmlStyle(style, true);
            children = (React.createElement("span", Object.assign({ style: newStyle }, attributes, props), leaf.emoji));
        }
        if (leaf.style) {
            const newStyle = getStyleFromHtmlStyle(style, true);
            children = (React.createElement("span", Object.assign({ style: newStyle }, attributes, props), children));
        }
        return leaf.style || leaf.emoji ? (React.createElement(React.Fragment, null, children)) : (React.createElement("span", Object.assign({ style: isParentHeading(props) ? headingStyle : undefined }, attributes, props), children));
    };
    const renderLeaf = useCallback((props) => React.createElement(Leaf, Object.assign({}, props)), []);
    const renderElement = useCallback((props) => {
        let style = props.element.style || {};
        const { attributes, element, children } = props;
        // style["textAlign"] = { textAlign: props.element.align };
        // if (
        //   props.element.type === "heading-1" ||
        //   props.element.type === "heading-2" ||
        //   props.element.type === "heading-3" ||
        //   props.element.type === "heading-4" ||
        //   props.element.type === "heading-5"
        // ) {
        //   delete style["fontSize"];
        // }
        switch (element.type) {
            case 'block-quote':
                return (React.createElement("blockquote", Object.assign({ style: style }, attributes), children));
            case 'bulleted-list':
                return (React.createElement("ul", Object.assign({ style: style }, attributes), children));
            case 'heading-1':
                return React.createElement("h1", { style: style }, children);
            case 'heading-2':
                return React.createElement("h2", { style: style }, children);
            case 'heading-3':
                return React.createElement("h3", { style: style }, children);
            case 'heading-4':
                return React.createElement("h4", { style: style }, children);
            case 'heading-5':
                return React.createElement("h5", { style: style }, children);
            case 'list-item':
                return (React.createElement("li", Object.assign({ style: style }, attributes), children));
            case 'numbered-list':
                return (React.createElement("ol", Object.assign({ style: style }, attributes), children));
            case 'div': {
                return React.createElement("div", null, children);
            }
            case 'align-left': {
                const style = element.style;
                return React.createElement("p", { style: style }, children);
            }
            case 'align-center': {
                const style = element.style;
                return React.createElement("p", { style: style }, children);
            }
            case 'align-right': {
                const style = element.style;
                return React.createElement("p", { style: style }, children);
            }
            case 'align-justify': {
                const style = element.style;
                return React.createElement("p", { style: style }, children);
            }
            case 'image': {
                const src = element.src;
                const alt = element.alt;
                const style = element.style;
                return (React.createElement("div", Object.assign({}, attributes),
                    children,
                    React.createElement("div", { contentEditable: false, className: css `
                                position: relative;
                            ` },
                        React.createElement("img", { src: src, alt: alt, style: style, className: css `
                                    display: block;
                                    max-width: 100%;
                                    max-height: 20em;
                                ` }),
                        React.createElement("button", { 
                            /* active */
                            onClick: (ev) => {
                                ev.preventDefault();
                                deleteImage(editor, element);
                            }, className: css `
                                    display: 'block';
                                    position: absolute;
                                    top: 0.5em;
                                    left: 0.5em;
                                    background-color: black;
                                    color: white;
                                    padding: 10px;
                                ` },
                            React.createElement(Icon, { buttonIcons: [] })))));
            }
            case 'image-center': {
                const src = element.src;
                const alt = element.alt;
                const style = element.style;
                return (React.createElement("div", Object.assign({}, attributes),
                    children,
                    React.createElement("div", { contentEditable: false, className: css `
                                position: relative;
                            ` },
                        React.createElement("img", { src: src, alt: alt, style: style, className: css `
                                    display: block;
                                    max-width: 100%;
                                    max-height: 20em;
                                ` }),
                        React.createElement("button", { 
                            /* active */
                            onClick: (ev) => {
                                ev.preventDefault();
                                deleteImage(editor, element);
                            }, className: css `
                                    display: 'block';
                                    position: absolute;
                                    top: 0.5em;
                                    left: 0.5em;
                                    background-color: black;
                                    color: white;
                                    padding: 10px;
                                ` },
                            React.createElement(Icon, { buttonIcons: [] })))));
            }
            case 'image-left': {
                const src = element.src;
                const alt = element.alt;
                const style = element.style;
                return (React.createElement("div", Object.assign({ style: { display: 'block' } }, attributes),
                    children,
                    React.createElement("div", { contentEditable: false, className: css `
                                position: relative;
                            `, style: { display: 'block' } },
                        React.createElement("img", { src: src, alt: alt, style: style, className: css `
                                    max-width: 100%;
                                    max-height: 20em;
                                ` }),
                        React.createElement("button", { 
                            /* active */
                            onClick: (ev) => {
                                ev.preventDefault();
                                deleteImage(editor, element);
                            }, className: css `
                                    display: 'block';
                                    position: absolute;
                                    top: 2em;
                                    left: 1em;
                                    background-color: black;
                                    color: white;
                                    padding: 10px;
                                ` },
                            React.createElement(Icon, { buttonIcons: [] })))));
            }
            case 'image-right': {
                const src = element.src;
                const alt = element.alt;
                const style = element.style;
                return (React.createElement("div", null,
                    children,
                    React.createElement("div", { style: { position: 'relative' } },
                        React.createElement("img", { src: src, alt: alt, style: style, className: css `
                                    max-width: 100%;
                                    max-height: 20em;
                                ` }),
                        React.createElement("button", { onClick: (ev) => {
                                ev.preventDefault();
                                deleteImage(editor, element);
                            }, className: css `
                                    display: 'block';
                                    position: absolute;
                                    top: 2em;
                                    right: 1em;
                                    background-color: black;
                                    color: white;
                                    padding: 10px;
                                ` },
                            React.createElement(Icon, { buttonIcons: [] })))));
            }
            case 'table': {
                const style = element.style;
                const className = element.className;
                if (style) {
                    return (React.createElement("table", Object.assign({ className: className, style: style }, attributes),
                        React.createElement("tbody", null, children)));
                }
                else {
                    return (React.createElement("table", Object.assign({}, attributes),
                        React.createElement("tbody", null, children)));
                }
            }
            case 'table-left': {
                const style = element.style;
                const className = element.className;
                if (style) {
                    return (React.createElement("table", Object.assign({ className: className, style: style }, attributes),
                        React.createElement("tbody", null, children)));
                }
                else {
                    return (React.createElement("table", Object.assign({}, attributes),
                        React.createElement("tbody", null, children)));
                }
            }
            case 'table-center': {
                const style = element.style;
                const className = element.className;
                if (style) {
                    return (React.createElement("table", Object.assign({ className: className, style: style }, attributes),
                        React.createElement("tbody", null, children)));
                }
                else {
                    return (React.createElement("table", Object.assign({}, attributes),
                        React.createElement("tbody", null, children)));
                }
            }
            case 'table-right': {
                const style = element.style;
                const className = element.className;
                if (style) {
                    return (React.createElement("table", Object.assign({ className: className, style: style }, attributes),
                        React.createElement("tbody", null, children)));
                }
                else {
                    return (React.createElement("table", Object.assign({}, attributes),
                        React.createElement("tbody", null, children)));
                }
            }
            case 'table-row': {
                const style = element.style;
                if (style) {
                    return (React.createElement("tr", Object.assign({ style: style }, attributes), children));
                }
                else {
                    return React.createElement("tr", Object.assign({}, attributes), children);
                }
            }
            case 'table-cell': {
                const style = element.style;
                if (style) {
                    return (React.createElement("td", Object.assign({ style: style }, attributes), children));
                }
                else {
                    return React.createElement("td", Object.assign({}, attributes), children);
                }
            }
            case 'link':
                return React.createElement(LinkComponent, Object.assign({}, props));
            case 'button':
                return React.createElement(EditableButtonComponent, Object.assign({}, props));
            case 'badge':
                return React.createElement(BadgeComponent, Object.assign({}, props));
            case 'embeded': {
                const style = element.style;
                const width = element.width;
                const height = element.height;
                const src = element.youtubeUrl;
                return React.createElement("iframe", { style: style, width: width, height: height, src: src, allowFullScreen: true });
            }
            default: {
                const style = element.children.style;
                if (style) {
                    return (React.createElement("p", Object.assign({ style: style }, attributes), children));
                }
                else {
                    return React.createElement("p", Object.assign({}, attributes), children);
                }
            }
        }
    }, []);
    const renderImageModal = () => {
        return (React.createElement(Modal, { isOpen: imageModal, toggle: toggleImageModal, backdrop: "static", size: "xl" },
            React.createElement(ModalHeader, null, "K\u00E9p felt\u00F6lt\u00E9se"),
            React.createElement(ModalBody, null, uploadType && uploadType === 'link' ? (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement(Label, null, "K\u00E9p linkje:"),
                    React.createElement(Input, { type: "text", value: image.src, onChange: (e) => {
                            setImage(Object.assign(Object.assign({}, image), { src: e.target.value }));
                        } })),
                React.createElement("div", null,
                    React.createElement(Label, null, "K\u00E9p alt tagje:"),
                    React.createElement(Input, { type: "text", value: image.alt, onChange: (e) => {
                            setImage(Object.assign(Object.assign({}, image), { alt: e.target.value }));
                        } })),
                React.createElement("div", null,
                    React.createElement(Label, null, "K\u00E9p sz\u00E9less\u00E9ge:"),
                    React.createElement(Input, { type: "text", value: image.width, onChange: (e) => {
                            setImage(Object.assign(Object.assign({}, image), { width: e.target.value }));
                        } })),
                React.createElement("div", null,
                    React.createElement(Label, null, "K\u00E9p magass\u00E1ga:"),
                    React.createElement(Input, { type: "text", value: image.height, onChange: (e) => {
                            setImage(Object.assign(Object.assign({}, image), { height: e.target.value }));
                        } })))) : (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement(Label, null, "K\u00E9p felt\u00F6lt\u00E9se:"),
                    React.createElement(Input, { type: "file" })),
                React.createElement("div", null, images &&
                    images.map((i) => {
                        return (React.createElement("div", { key: i.id },
                            React.createElement("img", { src: i.src, alt: i.alt })));
                    }))))),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { onClick: () => {
                        addImage(editor, image);
                        toggleImageModal();
                    } }, "OK"),
                React.createElement(Button, { type: "button", onClick: toggleImageModal }, "M\u00E9gsem"))));
    };
    const renderTableModal = () => {
        return (React.createElement(Modal, { isOpen: tableModal, toggle: toggleTableModal, backdrop: "static", size: "md" },
            React.createElement(ModalHeader, null, "T\u00E1bl\u00E1zat hozz\u00E1ad\u00E1sa"),
            React.createElement(ModalBody, null,
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "tableClass" }, "T\u00E1bl\u00E1zat oszt\u00E1lyneve: "),
                        React.createElement(Input, { type: "text", name: "tableClass", id: "tableClass", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { tableClass: e.target.value })), value: modalValues.tableClass })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "rowNumber" }, "T\u00E1bl\u00E1zat sorainak sz\u00E1ma: "),
                        React.createElement(Input, { type: "text", name: "rowNumber", id: "rowNumber", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { rowNumber: e.target.value })), value: modalValues.rowNumber })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "colNumber" }, "T\u00E1bl\u00E1zat oszlopainak sz\u00E1ma: "),
                        React.createElement(Input, { type: "text", name: "colNumber", id: "colNumber", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { colNumber: e.target.value })), value: modalValues.colNumber })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "textAlign" }, "T\u00E1bl\u00E1zat cellasz\u00F6veg\u00E9nek igaz\u00EDt\u00E1sa: "),
                        React.createElement(Input, { type: "select", name: "textAlign", id: "textAlign", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { textAlign: e.target.value })), value: modalValues.textAlign },
                            React.createElement("option", { key: "default", value: "left" }, "K\u00E9rj\u00FCk v\u00E1lasszon cellaigaz\u00EDt\u00E1st..."),
                            React.createElement("option", { key: "balra", value: "left" }, "Balra"),
                            React.createElement("option", { key: "center", value: "center" }, "K\u00F6z\u00E9pre"),
                            React.createElement("option", { key: "jobbra", value: "right" }, "Jobbra"))))),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { onClick: () => addTablazat(editor, modalValues.tableClass, parseInt(modalValues.rowNumber, 10), parseInt(modalValues.colNumber, 10), modalValues.textAlign) }, "Ment\u00E9s"),
                React.createElement(Button, { onClick: toggleTableModal }, "M\u00E9gsem"))));
    };
    const renderLinkModal = () => {
        return (React.createElement(Modal, { isOpen: linkModal, toggle: toggleLinkModal, backdrop: "static", size: "md" },
            React.createElement(ModalHeader, null, "Link hozz\u00E1ad\u00E1sa"),
            React.createElement(ModalBody, null,
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "linkUrl" }, "Link URL c\u00EDme: "),
                        React.createElement(Input, { type: "text", name: "linkUrl", id: "linkUrl", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { linkUrl: e.target.value })), value: modalValues.linkUrl })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "linkDesc" }, "Link sz\u00F6vege: "),
                        React.createElement(Input, { type: "text", name: "linkDesc", id: "linkDesc", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { linkDesc: e.target.value })), value: modalValues.linkDesc })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "linkFontColor" }, "Link bet\u0171sz\u00EDne: "),
                        React.createElement(Input, { type: "color", name: "linkFontColor", id: "linkFontColor", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { linkFontColor: e.target.value })), value: modalValues.linkFontColor })))),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { onClick: () => insertLink(editor, modalValues.linkUrl, modalValues.linkDesc, modalValues.linkFontColor) }, "Ment\u00E9s"),
                React.createElement(Button, { onClick: toggleLinkModal }, "M\u00E9gsem"))));
    };
    const renderYoutubeModal = () => {
        return (React.createElement(Modal, { isOpen: youtubeModal, toggle: toggleYoutubeModal, backdrop: "static", size: "md" },
            React.createElement(ModalHeader, null, "Youtube be\u00E1gyazott vide\u00F3 hozz\u00E1ad\u00E1sa"),
            React.createElement(ModalBody, null,
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "youtubeUrl" }, "Youtube vide\u00F3 URL c\u00EDme: "),
                        React.createElement(Input, { type: "text", name: "youtubeUrl", id: "youtubeUrl", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { youtubeUrl: e.target.value })), value: modalValues.youtubeUrl })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "youtubeWidth" }, "Vide\u00F3 sz\u00E9less\u00E9ge (px vagy %): "),
                        React.createElement(Input, { type: "text", name: "youtubeWidth", id: "youtubeWidth", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { youtubeWidth: e.target.value })), value: modalValues.youtubeWidth })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "youtubeHeight" }, "Vide\u00F3 magass\u00E1ga (px vagy %): "),
                        React.createElement(Input, { type: "text", name: "youtubeHeight", id: "youtubeHeight", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { youtubeHeight: e.target.value })), value: modalValues.youtubeHeight })))),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { onClick: () => {
                        addYoutube(editor, modalValues.youtubeUrl, modalValues.youtubeWidth, modalValues.youtubeHeight);
                        toggleYoutubeModal();
                    } }, "Ment\u00E9s"),
                React.createElement(Button, { onClick: toggleYoutubeModal }, "M\u00E9gsem"))));
    };
    const renderCTAModal = () => {
        return (React.createElement(Modal, { isOpen: CTAModal, toggle: toggleCTAModal, backdrop: "static", size: "md" },
            React.createElement(ModalHeader, null, "CTA gomb hozz\u00E1ad\u00E1sa"),
            React.createElement(ModalBody, null,
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "CTALeiras" }, "CTA gomb c\u00EDme: "),
                        React.createElement(Input, { type: "text", name: "CTALeiras", id: "CTALeiras", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { CTALeiras: e.target.value })), value: modalValues.CTALeiras })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "CTAFunc" }, "CTA gomb megnyom\u00E1s\u00E1nak URL-je: "),
                        React.createElement(Input, { type: "text", name: "CTAFunc", id: "CTAFunc", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { CTAFunc: e.target.value })), value: modalValues.CTAFunc })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "CTABgColor" }, "CTA gomb h\u00E1tt\u00E9rsz\u00EDne: "),
                        React.createElement(Input, { type: "color", name: "CTABgColor", id: "CTABgColor", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { CTABgColor: e.target.value })), value: modalValues.CTABgColor })),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Label, { for: "CTAFontColor" }, "CTA gomb bet\u0171sz\u00EDne: "),
                        React.createElement(Input, { type: "color", name: "CTAFontColor", id: "CTAFontColor", onChange: (e) => setModalvalues(Object.assign(Object.assign({}, modalValues), { CTAFontColor: e.target.value })), value: modalValues.CTAFontColor })))),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { onClick: () => addCTA(editor, modalValues.CTALeiras, modalValues.CTAFunc, modalValues.CTAFontColor, modalValues.CTABgColor) }, "Ment\u00E9s"),
                React.createElement(Button, { onClick: toggleCTAModal }, "M\u00E9gsem"))));
    };
    const renderEmojiModal = () => {
        return (React.createElement(Modal, { isOpen: emojiModal, toggle: toggleEmojiModal, backdrop: "static", size: "md" },
            React.createElement(ModalHeader, null, "Emoji hozz\u00E1ad\u00E1sa"),
            React.createElement(ModalBody, null, EmojiList.map((emoji) => {
                return (React.createElement("button", { key: emoji.name, style: { fontSize: '25px' }, onClick: () => {
                        addEmoji(editor, emoji.id);
                        setTimeout(() => {
                            toggleEmojiModal();
                        }, 200);
                    } },
                    React.createElement("span", null, emoji.id)));
            })),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { onClick: toggleEmojiModal }, "OK"))));
    };
    const setFont = (e, editor) => {
        const value = e.target.value;
        setFontSize(value);
        toggleFontsize(editor, value);
    };
    const setFontCol = (e, editor) => {
        const value = e.target.value;
        setFontColor(value);
        toggleFontColor(editor, value);
    };
    const toggleFontsize = (editor, value) => {
        const { selection } = editor;
        if (selection) {
            const [selectedText] = SlateEditor.leaf(editor, selection);
            let style = Object.assign({}, selectedText.style);
            let newStyle = Object.assign(style, { fontSize: value });
            editor.addMark('style', newStyle);
        }
    };
    const toggleFontColor = (editor, value) => {
        const { selection } = editor;
        if (selection) {
            const [selectedText] = SlateEditor.leaf(editor, selection);
            let style = Object.assign({}, selectedText.style);
            let newStyle = Object.assign(style, { color: value });
            editor.addMark('style', newStyle);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Component, { className: `wysiwyg-app ${className}`, style: { display: 'inline-grid', width: '100%' }, value: value, onChange: onChange, id: id, colors: colors, placeholder: placeholder, uploadType: uploadType, customButtons: customButtons },
            React.createElement(SharedAppContext.Provider, { value: {
                    value: value,
                    onChange: onChange,
                    id: id,
                    colors: colors,
                    placeholder: placeholder,
                    uploadType: uploadType,
                    customButtons: customButtons,
                    toggleBlock: toggleBlock,
                    toggleMark: toggleMark,
                    toggleFontColor: toggleFontColor,
                    toggleFontsize: toggleFontsize,
                    toggleCTAModal: toggleCTAModal,
                    toggleEmojiModal: toggleEmojiModal,
                    toggleImageModal: toggleImageModal,
                    toggleLinkModal: toggleLinkModal,
                    toggleTableModal: toggleTableModal,
                    toggleYoutubeModal: toggleYoutubeModal,
                    isBlockActive: isBlockActive,
                    isMarkActive: isMarkActive,
                    isLinkActive: isLinkActive,
                    isButtonActive: isButtonActive,
                    isUrl: isUrl,
                    isFontSizeActive: isFontSizeActive,
                    addText: addText,
                    unwrapLink: unwrapLink,
                    unwrapButton: unwrapButton,
                    editor: editor,
                    fontSize: fontSize,
                    fontColor: fontColor,
                    setFontColor: setFontColor,
                    setFontCol: setFontCol,
                    setFontSize: setFontSize,
                    setFont: setFont
                } },
                React.createElement(Slate, { editor: editor, initialValue: value, onChange: (v) => {
                        if (onChange) {
                            onChange(v);
                        }
                    } },
                    children,
                    React.createElement(Editable, { className: `react-slate-wysiwyg-editor ${editorClass}`, id: id, style: defaultStyle, placeholder: placeholder, renderLeaf: renderLeaf, renderElement: renderElement })))),
        imageModal ? renderImageModal() : '',
        renderTableModal(),
        renderLinkModal(),
        renderYoutubeModal(),
        renderCTAModal(),
        renderEmojiModal()));
};
export const SharedAppConsumer = SharedAppContext.Consumer;
//# sourceMappingURL=Wysiwyg.js.map